<template>
  <el-dialog
    :visible.sync="dialog"
    title="新增自定义组织"
    width="45%"
    :top="'15vh'"
    :close-on-click-modal="false"
    class="infoDialog"
  >
    <el-form
      label-width="100px"
      class="onDialog__form"
      :model="form"
      ref="form"
      :rules="rules"
    >
      <el-row>
        <el-col :span="12">
          <el-form-item label="组织名称" prop="deptName">
            <el-input
              v-model="form.deptName"
              size="large"
            ></el-input> </el-form-item
        ></el-col>
        <el-col :span="12">
          <el-form-item label="上级组织" prop="parentDeptName">
            <el-input
              size="large"
              :value="form.parentDeptName"
              :disabled="true"
            ></el-input> </el-form-item
        ></el-col>

        <el-col :span="12">
          <el-form-item label="组织类型" prop="roleId">
            <el-select
              size="large"
              style="width: 100%"
              v-model="form.deptType"
              @change="changeStatus"
            >
              <el-option
                v-for="item in deptType"
                :key="item.value"
                :label="item.name"
                :value="item.value"
              ></el-option> </el-select></el-form-item
        ></el-col>
        <template v-if="form.deptType == 6">
          <el-col :span="12">
            <el-form-item label="单位标签" prop="userName">
              <el-cascader
                style="width: 100%"
                size="large"
                :show-all-levels="false"
                v-model="form.deptLabels"
                :options="labelTree"
                :props="props"
                clearable
              ></el-cascader></el-form-item
          ></el-col>
          <el-col :span="12">
            <el-form-item label="负责人" prop="manager">
              <el-input
                v-model="form.manager"
                placeholder="负责人"
                size="large"
              ></el-input> </el-form-item
          ></el-col>
          <el-col :span="12">
            <el-form-item label="联系方式" prop="telephone">
              <el-input
                v-model="form.telephone"
                placeholder="联系方式"
                size="large"
              ></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="单位定位" prop="phone">
              <el-input
                v-model="form.lngLat"
                placeholder="请输入经纬度(经度，纬度)"
                size="large"
              ></el-input> </el-form-item
          ></el-col>
        </template>
      </el-row>
    </el-form>
    <div class="mapGroup" v-if="form.deptType == 6">
      <cmap :form="form" @MapObj="getPoi"></cmap>
      <!--      <div id="map4"></div>-->
      <!--      <div id="pickerBox">-->
      <!--        <input id="pickerInput" placeholder="输入关键字选取地点" />-->
      <!--        <div id="poiInfo"></div>-->
      <!--      </div>-->
    </div>

    <span slot="footer" class="dialog-footer">
      <el-button type="primary" @click="confirm">确 定</el-button>
      <el-button @click="dialog = false">取 消</el-button>
    </span>
  </el-dialog>
</template>

<script>
import Axios from "../../../../utils/Axios";
import cmap from "./bmap";
export default {
  name: "orgEditDialog",
  props: {
    userDefined: {
      type: Boolean,
      default: false,
    },
    deptInfo: {
      type: Object,
      default: () => {},
    },
  },
  components: { cmap },
  data() {
    let validateInput = (rule, value, callback) => {
      if (!this.checkSpecialKey(value)) {
        callback(new Error("不能含有特殊字符"));
      } else {
        callback();
      }
    }
    return {
      typeList: [],
      map: null,
      props: { multiple: true, value: "id", label: "name" },
      labelTree: [],
      deptType: [
        {
          name: "区域级",
          value: 1,
        },
        {
          name: "单位级",
          value: 6,
        },
      ],
      form: {
        lngLat: "",
        deptType: 1,
        parentDeptName: this.deptInfo.deptName,
      },
      rules: {
        deptName: [
          { required: true, message: "请输入单位名称", trigger: "blur" },
          { validator: validateInput, trigger: ['blur', 'change']  },//加上这一句
        ],
        parentDeptName: [
          { required: true, message: "请输入上层组织", trigger: "blur" },
        ],
      },
    };
  },
  watch: {},
  computed: {
    dialog: {
      get: function () {
        return this.userDefined;
      },
      set: function (newValue) {
        this.$emit("update:userDefined", newValue);
      },
    },
  },
  methods: {
    checkSpecialKey(str) {

      let specialKey = "[.。'<{}>]";

      for (let i = 0; i < str.length; i++) {

        if (specialKey.indexOf(str.substr(i, 1)) != -1) {
          return false;
        }
      }
      return true;
    },
    getPoi(obj) {
      this.form.lngLat = obj;
    },
    changeStatus(va) {
      this.form.deptType = va;
    },
    confirm() {
      this.$refs.form.validate((va) => {
        let lngLat = [];
        lngLat = this.form.lngLat.split(",");
        const deptLabels = [];
        if (Array.isArray(this.form.deptLabels)) {
          for (let i = 0; i < this.form.deptLabels.length; i++) {
            for (let j = 0; j < this.form.deptLabels[i].length; j++) {
              if (j == this.form.deptLabels[i].length - 1) {
                deptLabels.push(this.form.deptLabels[i][j]);
              }
            }
          }
        }
        if (va) {
          const data = {
            deptName: this.form.deptName || "",
            manager: this.form.manager || "",
            telephone: this.form.telephone || "",
            deptLabels: Array.isArray(this.form.deptLabels)
              ? deptLabels.toString()
              : this.form.deptLabels,
            lat: lngLat.length ? lngLat[1] : "",
            lng: lngLat.length ? lngLat[0] : "",
            deptType: this.form.deptType || 1,
            parentId: this.deptInfo.issolo?this.deptInfo.parentId:this.deptInfo.deptId || 1,
          };
          Axios.ajax({
            url: "/dept/add",
            method: "post",
            data: data,
          }).then((res) => {
            if (res.resultCode == 0) {
              this.$message.success("添加成功！");
              this.$emit("update");
              this.dialog = false;
            } else {
              this.$message.warning("添加失败！");
            }
          });
        }
      });
    },
    initMap(station) {
      let that = this;
      const map = (this.map = new AMap.Map("map4", {
        center: [120.21937542, 30.25924446],
        zoom: 14,
        pitch: 30, // 地图俯仰角度，有效范围 0 度- 83 度
        resizeEnable: true,
        expandZoomRange: true,
        zooms: [3, 20],
        showBuildingBlock: true,
      }));
      that.stationLayer = new AMap.OverlayGroup();
      if (station) {
        const marker = new AMap.Marker({
          label: {
            content: station.deptName,
            direction: "top", //决定提示内容在icon的方位
          },
          icon: require("../../img/img.png"),
          position: new AMap.LngLat(station.lng, station.lat),
          zIndex: 1000,
          extData: station,
        });
        map.add(marker);
      }
    },
    queryLabelTree() {
      Axios.ajax({
        url: "/label/tree",
        method: "get",
      }).then(({ data }) => {
        this.labelTree = data;
      });
    },
  },
  created() {
    this.queryLabelTree();
  },
  mounted() {
    this.$nextTick(() => {
      this.initMap();
    });
  },
  beforeDestroy() {},
};
</script>

<style lang="less" scoped>
#map4 {
  width: 100%;
  height: 220px;
  margin-left: 10px;
  margin-bottom: 42px;
}
#pickerBox {
  position: absolute;
  z-index: 9999;
  top: 20px;
  left: 20px;
  width: 300px;
}
#pickerInput {
  width: 200px;
  padding: 5px 5px;
}
#poiInfo {
  background: #fff;
}
.mapGroup {
  position: relative;
}
.infoDialog {
}
</style>
